
import Vue from "vue";
import Component from "vue-class-component";
import HeaderRegister from "@/components/register/HeaderRegister.vue";
import AppFooter from "@/components/layout/AppFooter.vue";
import { Action, Getter } from "vuex-class";
import AppNavbarSecondary from "@/components/layout/AppNavbarSecondary.vue";
import News from "@/components/content-management/news/News.vue";
import { AxiosResponse } from "axios";
import { isValidIpUrl, isValidUrl } from "@/functions/global.function";
import { SUBDOMAIN } from "@/constants/portal.constant";
import getBrowserType from "@/functions/getBrowserType";

@Component({
  components: {
    AppNavbarSecondary,
    HeaderRegister,
    AppFooter,
    News,
  },
})
export default class TracerStudy extends Vue {
  @Action("tracerStudyLogin", { namespace: "school" })
  private tracerStudyLogin: any;
  @Action("getTracerDetail", { namespace: "school" })
  private getTracerDetail: any;

  @Getter("twoColor")
  private twoColor!: { text: string; bg: string; border: string };

  private studentNumber = "";
  private nationalStudentNumber = "";
  private tracerStudy = null;

  private get twoBgColor() {
    return this.twoColor.bg;
  }
  private get tracerId() {
    try {
      return parseInt(atob(this.$route.params.code));
    } catch (e) {
      return null;
    }
  }
  private get templateNumber() {
    return Number(this.$route.query.template) || 1;
  }

  private created() {
    this.getTracerDetail({
      params: {
        id: this.tracerId,
      },
      success: (response: AxiosResponse) => {
        this.tracerStudy = response.data.data;
      },
    });
  }

  private submit() {
    this.tracerStudyLogin({
      params: {
        student_number: this.studentNumber,
        national_student_number: this.nationalStudentNumber,
      },
      success: (res: AxiosResponse) => {
        if (isValidIpUrl(res.data.data.url) || isValidUrl(res.data.data.url))
          window.open(
            res.data.data.url,
            getBrowserType() === "Mozilla Firefox" ? "_self" : "_blank"
          );
        else
          window.open(
            `${window.location.origin}${
              window.location.origin.includes(SUBDOMAIN) ? "" : `/${SUBDOMAIN}`
            }${res.data.data.url}`,
            getBrowserType() === "Mozilla Firefox" ? "_self" : "_blank"
          );
      },
    });
  }
}
